import { Button, Col, Grid, message, Row, Space, Typography } from "antd";
import {
  ACTIONTYPES,
  useStore,
  useStoreDispatch,
} from "../../../context/CreateStoreContext";
import style from "./StoreDetails.module.css";
import { useEffect, useState } from "react";
import { getCheckoutLinkV2 } from "../../../components/apiRepository/DynamodbRepository";
import { useNavigate } from "react-router-dom";
import { type } from "@testing-library/user-event/dist/type";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export default function Notice() {
  const screen = useBreakpoint();
  const { selectedStore } = useStore();
  const dispatch = useStoreDispatch();
  const [showNotice, setShowNotice] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCheckoutNow = async () => {
    dispatch({
      type: ACTIONTYPES.STORE,
      data: {
        address: selectedStore?.address,
        name: selectedStore?.storeName,
      },
    });

    setLoading(true);
    await getCheckoutLinkV2({
      storeId: selectedStore?.storeId,
      accountType: selectedStore?.accountType,
    })
      .then((data) => {
        setLoading(false);
        const clientSecret = data?.body?.setupIntent || undefined;
        if (clientSecret) {
          dispatch({
            type: ACTIONTYPES.STRIPECLIENT,
            data: { clientSecret, fromAdmin: true, completing: true },
          });
          setTimeout(() => {
            navigate("/checkout");
          }, 1000);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        messageApi.open({
          type: "error",
          content: "Request failed.",
        });
      });
  };

  useEffect(() => {
    setShowNotice(
      () =>
        selectedStore?.stripeSubscription?.subscriptionStatus === "inactive",
    );
  }, [selectedStore]);

  return showNotice ? (
    <>
      {contextHolder}
      <Row align="middle" justify="space-between" className={style.Notice}>
        <Col>
          <Row gutter={12}>
            <Col>
              <svg
                width={screen.xs ? "40" : "50"}
                height={screen.xs ? "40" : "50"}
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="25"
                  cy="25"
                  r="25"
                  fill="url(#paint0_linear_1033_5327)"
                />
                <path
                  d="M16.2971 32.8V26.2C16.2971 21.3399 20.1935 17.4 25 17.4C29.8065 17.4 33.7028 21.3399 33.7028 26.2V32.8H34.7907V35H15.2093V32.8H16.2971ZM18.4729 26.2H20.6486C20.6486 23.77 22.5968 21.8 25 21.8V19.6C21.3952 19.6 18.4729 22.5549 18.4729 26.2ZM23.9121 13H26.0878V16.3H23.9121V13ZM33.4616 16.0884L35 17.644L32.6923 19.9775L31.1539 18.4218L33.4616 16.0884ZM15 17.644L16.5385 16.0884L18.8461 18.4218L17.3077 19.9775L15 17.644Z"
                  fill="white"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1033_5327"
                    x1="7.5"
                    y1="7"
                    x2="44.5"
                    y2="43.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF3B30" />
                    <stop offset="1" stop-color="#FF3B30" stop-opacity="0.8" />
                  </linearGradient>
                </defs>
              </svg>
            </Col>
            <Col>
              <Space direction="vertical" size={0}>
                <Text className={style.Title}>
                  Oops! Your subscription isn't active yet.
                </Text>
                <Text className={style.Description}>
                  Complete checkout to set up payment and activate your
                  subscription.
                </Text>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            size="large"
            className={style.Button}
            onClick={handleCheckoutNow}
            iconPosition="end"
            loading={loading}
          >
            Checkout Now
          </Button>
        </Col>
      </Row>
    </>
  ) : null;
}
